import httpClient from '@/shared/http-eserv-client';

const postDocument = (data) => httpClient.post('/Documents', data);

const isSiteReviewReady = (emailAddress, ownerId, ownerContactId, requestId) => httpClient.get(`/SiteReviews/IsSiteReviewReady?emailAddress=${emailAddress}&ownerId=${ownerId}&ownerContactId=${ownerContactId}&requestId=${requestId}`);

const uploadSiteReviewFile = (data) => httpClient.post('/SiteReviews/UploadDocument', data);

const deleteSiteReviewFile = (documentId) => httpClient.delete(`/SiteReviews/${documentId}`);

const getSiteReviewDocuments = (userId) => httpClient.get(`/SiteReviews/GetSiteReviewDocumentsByUserId?userid=${userId}`);

const saveSiteReviewData = (data) => httpClient.post('/SiteReviews', data);

const approveReviewData = (email, ownerId, ownerContactId, requestId) => httpClient.post(`/SiteReviews/approve?emailAddress=${email}&ownerId=${ownerId}&ownerContactId=${ownerContactId}&requestId=${requestId}`, null);

const reopenReviewData = (email, ownerId, ownerContactId, requestId) => httpClient.post(`/SiteReviews/reopen?emailAddress=${email}&ownerId=${ownerId}&ownerContactId=${ownerContactId}&requestId=${requestId}`, null);

const submitReviewData = (email, ownerId, ownerContactId, requestId) => httpClient.post(`/SiteReviews/submit?emailAddress=${email}&ownerId=${ownerId}&ownerContactId=${ownerContactId}&requestId=${requestId}`, null);

export {
  postDocument,
  isSiteReviewReady,
  uploadSiteReviewFile,
  deleteSiteReviewFile,
  getSiteReviewDocuments,
  saveSiteReviewData,
  approveReviewData,
  reopenReviewData,
  submitReviewData,
};
